import React, { useContext } from 'react';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import Utils from '../../../utils/Utils';
import moment from 'moment';
import AiTrainingDataContext from '../../AiTrainingDataContext';
import PropTypes from 'prop-types';
import SelectWithLabel from '../../../components/common/SelectWithLabel';

function AiTrainingDataFilters(props) {
    const {
        dispatchMessageToDisplay,
        appliedFiltersData,
        dispatchFiltersToApply,
    } = props;
    const {
        statusListItems,
        fetchCallRecordingData,
        setLoading,
        resetCallRecordingData,
    } = useContext(AiTrainingDataContext);

    const resetFilters = () => {
        dispatchFiltersToApply({
            type: 'RESET',
        });
        resetCallRecordingData();
    };

    const validateAndFetchCallRecordingData = async () => {
        try {
            //do some basic validations
            if (
                !appliedFiltersData.fromTimeStamp &&
                !appliedFiltersData.toTimeStamp &&
                !appliedFiltersData.status
            ) {
                //alert('Please select at least one filter');
                dispatchMessageToDisplay({
                    type: 'SHOW_ERROR_MESSAGE',
                    payload: {
                        showMessage: true,
                        message: 'Please select at least one filter',
                        isSuccessMessage: false,
                    },
                });
                return;
            }
            setLoading(true);
            await fetchCallRecordingData(appliedFiltersData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            dispatchMessageToDisplay({
                type: 'SHOW_ERROR_MESSAGE',
                payload: {
                    showMessage: true,
                    message: `Failed to fetch data. ${error.message}`,
                    isSuccessMessage: false,
                },
            });
            console.error('Error fetching call recording data:', error);
        }
    };

    return (
        <Grid container item spacing={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
            <Grid item xs={12}>
                <Typography variant="h5" sx={{ mb: 0 }}>
                    Filters
                </Typography>
            </Grid>

            <Grid item xs={12} sm={5} md={3} lg={5} justifyContent={'center'}>
                <DateTimePicker
                    id="createdTimeStart"
                    label="From Date"
                    value={appliedFiltersData.fromTimeStamp}
                    inputVariant="outlined"
                    onChange={(value) => {
                        dispatchFiltersToApply({
                            type: 'SET_FROM_TIMESTAMP',
                            value,
                        });
                    }}
                    minDate={moment(Utils.getDateWithOffset(-120))}
                    maxDate={moment(new Date())}
                    selected={moment(appliedFiltersData.fromTimeStamp)}
                    renderInput={(props) => (
                        <TextField
                            size="small"
                            {...props}
                            sx={{ mr: 1, minWidth: '160px' }}
                        />
                    )}
                />
                <DateTimePicker
                    id="createdTimeEnd"
                    label="To Date"
                    value={appliedFiltersData.toTimeStamp}
                    autoOk
                    inputVariant="outlined"
                    onChange={(value) => {
                        dispatchFiltersToApply({
                            type: 'SET_TO_TIMESTAMP',
                            value,
                        });
                    }}
                    minDate={moment(
                        appliedFiltersData.fromTimeStamp
                            ? appliedFiltersData.fromTimeStamp
                            : Utils.getDateWithOffset(-180)
                    )}
                    maxDate={moment(new Date())}
                    selected={moment(appliedFiltersData.toTimeStamp)}
                    renderInput={(props) => (
                        <TextField
                            size="small"
                            {...props}
                            sx={{ minWidth: '180px' }}
                        />
                    )}
                />
                <Typography
                    variant="inherit"
                    sx={{
                        fontSize: '0.75em',
                        fontWeight: 'bold',
                        marginTop: 0,
                        marginBottom: 0,
                    }}
                >
                    *Date and Time as per Restaurant TimeZone
                </Typography>
            </Grid>

            <Grid item xs={12} sm={4} md={3} lg={2}>
                <SelectWithLabel
                    items={statusListItems}
                    id="selectStatus"
                    label="Status"
                    size="small"
                    minWidth={180}
                    value={appliedFiltersData.status}
                    onChangeHandler={(value) =>
                        dispatchFiltersToApply({
                            type: 'SET_STATUS',
                            value: value,
                        })
                    }
                ></SelectWithLabel>
            </Grid>

            <Grid item xs={12} sm={2} md={3} lg={2}>
                <Button
                    color="primary"
                    style={{
                        height: 'max-content',
                        marginRight: '10px',
                    }}
                    variant="contained"
                    onClick={validateAndFetchCallRecordingData}
                >
                    Fetch
                </Button>
                <Button
                    color="primary"
                    style={{
                        height: 'max-content',
                        //marginLeft: '10px',
                    }}
                    variant="outlined"
                    onClick={resetFilters}
                >
                    Reset
                </Button>
            </Grid>
        </Grid>
    );
}

AiTrainingDataFilters.propTypes = {
    dispatchMessageToDisplay: PropTypes.func.isRequired,
    appliedFiltersData: PropTypes.object.isRequired,
    dispatchFiltersToApply: PropTypes.func.isRequired,
};

export default AiTrainingDataFilters;
